import { type VariantProps, cva } from "class-variance-authority";
import { X } from "lucide-react";
import * as React from "react";
import { cn } from "../../lib/utils";

const tagVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-100 text-14 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-0",
  {
    variants: {
      variant: {
        base: "bg-neutral-700 text-neutral-0",
        secondary: "bg-orange-50 text-neutral-800",
        tertiary: "bg-neutral-50 text-neutral-800",
        danger: "bg-red-300 text-neutral-800",
      },
      size: {
        default: "pl-3 pr-2 py-2 text-16",
        sm: "pl-2 pr-1 py-1 text-14",
      },
    },
    defaultVariants: {
      variant: "base",
      size: "default",
    },
  }
);

export interface TagProps
  extends Omit<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    keyof VariantProps<typeof tagVariants>
  > {
  variant?: VariantProps<typeof tagVariants>["variant"];
  size?: VariantProps<typeof tagVariants>["size"];
  iconPrefix?: React.ReactElement;
}

function Tag({
  className,
  variant = "base",
  size = "default",
  children,
  iconPrefix,
  ...props
}: TagProps) {
  return (
    <button
      {...props}
      className={cn(
        tagVariants({ variant, size }),
        "cursor-pointer",
        className
      )}
    >
      {iconPrefix && React.cloneElement(iconPrefix, { className: "h-4 w-4" })}
      {children}
      <X className="h-4 w-4" />
    </button>
  );
}

export { Tag, tagVariants };
